import { mapGetters } from 'vuex';
import enJSON from '../../../common/utilities/lang/en/footer.js';
import esJSON from '../../../common/utilities/lang/es/footer.js';
import mvtShareLink from '../mvtsharelink/mvt-sharelink.vue';
import mvtCompliance from '../mvtcompliance/mvt-compliance.vue';
import { getPathBySearchObj } from '../../../../widget/spec/searchHelper';

export default {
    name: 'mvtFooter',
    root: true,
    inject: ['$eventBus'],
    props: ['geoInfo'],
    data() {
        return {
            isMounted: false,
        };
    },
    computed: {
        ...mapGetters('glb', ['glb', 'getPhoneNumber']),
        geo() {
            //if no geoInfo, keep geo empty
            return this.geoInfo || null;
        },
        menu() {
            const isLoggedIn = this.glb.user?.id && this.isMounted;
            const { appUrl, user } = this.glb;
            const geo = this.geo || {};
            const hasGeo = geo.hasGeoInfo;

            const getLinkFromGeo = () => {
                if (!hasGeo) {
                    return {
                        forSale: `${appUrl}for-sale/`,
                        forRent: `${appUrl}rentals/`,
                    };
                }

                switch (geo.geoType) {
                    case 'NEIGHBORHOOD':
                    case 'CITY':
                    case 'ADDRESS': {
                        const basePath = geo.cityPath ? geo.cityPath : getPathBySearchObj({ city: geo.city, state: geo.state }, null, true);
                        return {
                            forSale: appUrl + basePath,
                            forRent: appUrl + getPathBySearchObj({ city: geo.city, state: geo.state }, { rentals: true }, true),
                        };
                    }
                    case 'STATE': {
                        return {
                            forSale: `${appUrl}sitemap/${geo.stateCode}/`,
                            forRent: `${appUrl}sitemap/${geo.stateCode}/rentals/`,
                        };
                    }
                    default: {
                        const basePath = geo.path || getPathBySearchObj(geo, null, true);
                        return {
                            forSale: appUrl + basePath,
                            forRent: appUrl + getPathBySearchObj(geo, { rentals: true }, true),
                        };
                    }
                }
            };

            const { forSale, forRent } = getLinkFromGeo();

            const home = [
                { title: this.molang('footer.FindaHome') },
                { text: this.molang('footer.HomesforSale'), href: forSale },
                { text: this.molang('footer.HomesforRent'), href: forRent },
                { text: this.molang('footer.SellYourHome'), href: `${appUrl}sell/` },
                { text: this.molang('footer.GetaHomeValuation'), href: `${appUrl}what-is-your-home-worth/` },
                { text: this.molang('footer.MortgageCalculator'), href: `${appUrl}mortgages/calculator/` },
            ];

            const agent = [
                { title: this.molang('footer.AgentProfessionals') },
                { text: this.molang('footer.Agent'), href: `${appUrl}agents/` },
                { text: this.molang('footer.BecomeaMovotoAgent'), href: 'https://agents.movoto.com/platforms/' },
            ];

            const getAccountLinks = () => {
                const common = [
                    { text: this.molang('footer.sitemap'), href: `${appUrl}sitemap/` },
                    { text: this.molang('footer.getApp'), href: `${appUrl}mobile/` },
                ];

                if (isLoggedIn) {
                    return [
                        { title: this.molang('footer.YourMovoto') },
                        { text: this.molang('footer.savedHomes'), href: `${appUrl}my-movoto/favorites/` },
                        { text: this.molang('footer.savedSearches'), href: `${appUrl}my-movoto/saved-searches/` },
                        { text: this.molang('footer.profile'), href: `${appUrl}my-movoto/account/` },
                        ...common,
                    ];
                } else {
                    return [
                        { title: this.molang('footer.YourMovoto') },
                        { text: this.molang('footer.SignIn'), click: this.showLogin },
                        { text: this.molang('footer.Join'), click: this.showSignup },
                        { text: this.molang('footer.savedHomes'), url: `${appUrl}my-movoto/favorites/`, click: this.showLogin },
                        { text: this.molang('footer.savedSearches'), url: `${appUrl}my-movoto/saved-searches/`, click: this.showLogin },
                        { text: this.molang('footer.profile'), url: `${appUrl}my-movoto/account/`, click: this.showLogin },
                        ...common,
                    ];
                }
            };

            const about = [
                { title: this.molang('footer.CustomerService') },
                { text: this.molang('footer.Faqs'), href: `${appUrl}faqs/` },
                { text: this.molang('footer.HelpCenter'), href: 'https://help.movoto.com/' },
                { text: this.molang('footer.blog'), href: `${appUrl}blog/` },
                { text: this.molang('footer.guide'), href: `${appUrl}guide/` },
                { text: this.molang('footer.ContactUs'), click: this.openContact },
                { text: 'Careers', href: 'https://careers.lower.com/' },
            ];

            return [home, agent, getAccountLinks(), about];
        },
    },
    components: {
        mvtShareLink,
        mvtCompliance,
    },
    methods: {
        showLogin: function (link) {
            let url = link && link.url ? link.url : undefined;
            this.$eventBus.$emit('dialog-center', { name: 'mvtAuthenticate', opt: { type: 'mvtLogin', redirectUrl: url }, trigger: this.$options.name });
        },
        showSignup: function () {
            this.$eventBus.$emit('dialog-center', { name: 'mvtAuthenticate', opt: { type: 'mvtLogin' }, trigger: this.$options.name });
        },
        openContact: function (payload) {
            var hotleadOpt = {
                hotleadTitle: this.molang('common.ContactUs'),
                hotleadType: this.glb.isMobile ? 'ContactMovotoMobile' : 'ContactMovotoDesktop',
                buttonText: this.molang('footer.send'),
                showComment: true,
                hideVeteran: true,
                profileUrl: 'icon-envelope',
                enquiryType: payload?.enquiryType,
            };
            this.$eventBus.$emit('dialog-center', { name: 'mvtHotleadForm', trigger: this.$options.name, opt: hotleadOpt });
        },
    },
    mounted() {
        this.isMounted = true;
        this.$eventBus.$on('dialog-open-contactus', this.openContact);
    },
    beforeCreate() {
        this.injectMolangDataStore({ type: 'footer', en: enJSON, es: esJSON });
    },
};
